import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../shared/AuthContext";
import AdminOrders from "./AdminOrders";
import AdminProducts from "./AdminProducts";
import AdminDelivery from "./AdminDelivery";
import "./Admin.scss";

export default function AdminDashboard() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("orders");
  const [focusOrderId, setFocusOrderId] = useState(null);

  const goToOrder = (orderId) => {
    setFocusOrderId(orderId);
    setTab("orders");
  };

  const handleSignOut = async () => {
    await signOut();
    navigate("/admin/login");
  };

  return (
    <div className="admin">
      <div className="admin__sidebar">
        <div className="admin__logo">✝ Admin</div>
        <nav className="admin__nav">
          <button
            className={`admin__nav-btn ${tab === "orders" ? "active" : ""}`}
            onClick={() => setTab("orders")}
          >
            📦 Porudžbine
          </button>
          <button
            className={`admin__nav-btn ${tab === "products" ? "active" : ""}`}
            onClick={() => setTab("products")}
          >
            🖼 Proizvodi
          </button>
          <button
            className={`admin__nav-btn ${tab === "delivery" ? "active" : ""}`}
            onClick={() => setTab("delivery")}
          >
            🚚 Dostava
          </button>
        </nav>
        <div className="admin__user">
          <span>{user?.email}</span>
          <button className="admin__signout" onClick={handleSignOut}>Odjavi se</button>
        </div>
      </div>

      <div className="admin__content">
        {tab === "orders" && <AdminOrders focusOrderId={focusOrderId} onFocusHandled={() => setFocusOrderId(null)} />}
        {tab === "products" && <AdminProducts />}
        {tab === "delivery" && <AdminDelivery onGoToOrder={goToOrder} />}
      </div>
    </div>
  );
}
